<template>
  <footer class="bg-[#0B081A] border-t border-white/5">
    <div class="w-full max-w-screen-xl mx-auto p-6 md:py-8">
      <div class="flex items-center justify-center">
        <a href="#home" class="flex items-center mb-4 sm:mb-0 transition-transform duration-300 hover:scale-105">
          <img :src="logoToShow" class="h-16 md:h-20" alt="Logo" />
        </a>
      </div>

      <hr class="border-white/10 sm:mx-auto my-6 lg:my-8" />
      <div class="text-center text-slate-300 font-medium py-2 text-sm tracking-wide">
        <span>
          {{ hasCustomSocials ? translations[language].followGame : translations[language].followUs }}
        </span>
      </div>

      <div class="font-regular text-white">
        <div class="flex items-center justify-center space-x-6 pb-6">
          <template v-if="hasCustomSocials">
            <template v-for="(link, idx) in footerSocialLinks" :key="idx">
              <a
                  v-if="link.type && link.url"
                  :href="link.url"
                  target="_blank"
                  rel="noopener"
                  :title="capitalize(link.type)"
                  class="transition-all duration-300 hover:scale-110 hover:brightness-110 filter hover:drop-shadow-[0_0_12px_rgba(96,38,158,0.5)]"
              >
                <img
                    v-if="link.type === 'instagram'"
                    src="../../assets/instagram.svg"
                    class="h-10 w-10 md:h-12 md:w-12"
                    alt="instagram"
                />
                <img
                    v-else-if="link.type === 'facebook'"
                    src="../../assets/facebook.svg"
                    class="h-10 w-10 md:h-12 md:w-12"
                    alt="facebook"
                />
                <img
                    v-else-if="link.type === 'youtube'"
                    src="../../assets/youtube.svg"
                    class="h-10 w-10 md:h-12 md:w-12"
                    alt="youtube"
                />
                <img
                    v-else-if="link.type === 'twitter' || link.type === 'x'"
                    src="../../assets/x.svg"
                    class="h-10 w-10 md:h-12 md:w-12"
                    alt="twitter"
                />
                <img
                    v-else-if="link.type === 'linkedin'"
                    src="../../assets/linkedin.svg"
                    class="h-10 w-10 md:h-12 md:w-12"
                    alt="linkedin"
                />
              </a>
            </template>
          </template>
          <template v-else>
            <a href="https://www.facebook.com/mitogamesbr" class="transition-all duration-300 hover:scale-110 hover:brightness-110 filter hover:drop-shadow-[0_0_12px_rgba(96,38,158,0.5)]">
              <img src="../../assets/facebook.svg" class="h-8 w-8 md:h-10 md:w-10" alt="facebook" />
            </a>
            <a href="https://www.instagram.com/mitogames/" class="transition-all duration-300 hover:scale-110 hover:brightness-110 filter hover:drop-shadow-[0_0_12px_rgba(96,38,158,0.5)]">
              <img src="../../assets/instagram.svg" class="h-8 w-8 md:h-10 md:w-10" alt="instagram" />
            </a>
            <a href="https://www.linkedin.com/company/mito-games-ltda/" class="transition-all duration-300 hover:scale-110 hover:brightness-110 filter hover:drop-shadow-[0_0_12px_rgba(96,38,158,0.5)]">
              <img src="../../assets/linkedin.svg" class="h-8 w-8 md:h-10 md:w-10" alt="linkedin" />
            </a>
            <a href="https://www.youtube.com/@mitogames8036" class="transition-all duration-300 hover:scale-110 hover:brightness-110 filter hover:drop-shadow-[0_0_12px_rgba(96,38,158,0.5)]">
              <img src="../../assets/youtube.svg" class="h-8 w-8 md:h-10 md:w-10" alt="youtube" />
            </a>
            <a href="https://twitter.com/mitogamesbrasil" class="transition-all duration-300 hover:scale-110 hover:brightness-110 filter hover:drop-shadow-[0_0_12px_rgba(96,38,158,0.5)]">
              <img src="../../assets/x.svg" class="h-8 w-8 md:h-10 md:w-10" alt="twitter" />
            </a>
          </template>
        </div>
      </div>
    </div>
    <div>
      <span class="block text-sm bg-[#60269E] w-full text-white text-center py-2.5 tracking-wide font-medium">© {{ currentYear }}<a class="font-bold"> Mito Games.</a> {{ translations[language].allRightsReserved }}</span>
    </div>
  </footer>
</template>

<script>
import defaultLogo from "@/assets/logo.png";

export default {
  name: "Footer",
  props: {
    language: {
      type: String,
      default: 'pt'
    },
    footerLogo: {
      // Aceita tanto String quanto Array
      type: [String, Array],
      default: ""
    },
    footerSocialLinks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      translations: {
        pt: {
          followUs: 'Siga-nos nas redes sociais',
          followGame: 'Siga as redes sociais do jogo',
          privacyPolicy: 'Termo de privacidade',
          deleteAccount: 'Deletar conta',
          allRightsReserved: 'Todos os direitos reservados'
        },
        en: {
          followUs: 'Follow us on social media',
          followGame: 'Follow the game on social media',
          privacyPolicy: 'Privacy Policy',
          deleteAccount: 'Delete account',
          allRightsReserved: 'All rights reserved'
        }
      }
    };
  },
  computed: {
    logoToShow() {
      // Se for array e tiver pelo menos um item, usa o primeiro
      if (Array.isArray(this.footerLogo) && this.footerLogo.length > 0) {
        return this.footerLogo[0];
      }
      // Se for string válida, usa a string
      if (typeof this.footerLogo === "string" && this.footerLogo.length > 4) {
        return this.footerLogo;
      }
      // Se não, usa a default
      return defaultLogo;
    },
    hasCustomSocials() {
      return Array.isArray(this.footerSocialLinks) && this.footerSocialLinks.some(link => link.type && link.url);
    }
  },
  methods: {
    capitalize(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  }
};
</script>
